import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLineRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 12h14.25M10.5 5.25 17.25 12l-6.75 6.75M20.25 3.75v16.5"
    />
  </svg>
);
export default SvgArrowLineRight;
